export const isTruthy = a => !!a;
export const isNullOrUndefined = (val) => val === null || val === undefined;
export const replaceUndefined = <T>(val: T, replacement: T): T => val === undefined ? replacement : val;
